import m from "../../../../geodata/es2015/region/world/europeHigh";
window.am4geodata_region_world_europeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/europeHigh.js
// module id = null
// module chunks = 